export const MAIN_FONT = `Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif`;
export const GRID_FONT = "Inter";
export const TABLE_FONT = "IBM Plex Sans, sans-serif";
